module.exports = __webpack_public_path__ + "static/media/thumbnail.a5141c88.jpg";